import { Skeleton } from "@mui/material";

export const HomeBannerSkeleton: React.FC = () => {
  return (
    <Skeleton
      variant="rounded"
      animation="wave"
      height={200}
      sx={{ borderRadius: 2 }}
    />
  );
};
